/**
 * Linkit marketing design tokens.
 *
 * Deliberately editorial and warm — no purple gradients, no glowing cards,
 * no floating orbs. Warm cream background, near-black ink, single warm-terra
 * accent, Fraunces serif for display, Manrope sans for body/UI.
 *
 * Consumed via inline `style={THEME}` on marketing route roots and via
 * className tokens (see index.css classes prefixed with `lm-`).
 */

export const THEME = {
  // Base surfaces
  "--lm-cream": "#F8F5EE",
  "--lm-cream-2": "#F1ECDF",
  "--lm-paper": "#FFFFFF",
  // Ink hierarchy
  "--lm-ink": "#1A1613",
  "--lm-ink-2": "#3D3530",
  "--lm-ink-3": "#6B615A",
  "--lm-ink-4": "#9E9086",
  // Hairline borders / dividers
  "--lm-hair": "rgba(26, 22, 19, 0.10)",
  "--lm-hair-strong": "rgba(26, 22, 19, 0.20)",
  // Warm terracotta accent — creator-led, editorial, distinctive
  "--lm-terra": "#B84A26",
  "--lm-terra-dark": "#8B3319",
  "--lm-terra-light": "#F7E4D6",
  // Type
  "--lm-display": "'Fraunces', ui-serif, Georgia, serif",
  "--lm-sans": "'Manrope', ui-sans-serif, system-ui, sans-serif",
  // Radii
  "--lm-r-sm": "8px",
  "--lm-r-md": "12px",
  "--lm-r-lg": "20px",
  "--lm-r-pill": "999px",
  // Root
  background: "#F8F5EE",
  color: "#1A1613",
  fontFamily: "'Manrope', ui-sans-serif, system-ui, sans-serif",
  minHeight: "100vh",
};
